import axiosInstance from "../utils/axiosConfig"

/**
    * @function getIndustry
    * @param ({ filter, offset })
    * @description api to get industry list
*/
export const getIndustry = async ({ filter, offset }) => {
    try {
        const result = await axiosInstance.get(`industry?offset=${offset}&filter=${filter}`);
        return result;
    } catch (error) {
        console.error('[IndustryService] API Error:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status
        });
        throw error;
    }
}

/**
    * @function getAllIndustryListService
    * @param ({ authToken })
    * @description call API to get the dimension list
*/
export const getAllIndustryListService = async ({ authToken }) => {
    try {
        const result = await axiosInstance.get(`industry?filter=Active&getAll=true`, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        });
        return result;
    } catch (error) {
        console.error('[IndustryService] API Error:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status
        });
        throw error;
    }
}